import React from 'react';
import { useElevate } from '../ElevateContext';
import { ElevateFacetAccordion } from './ElevateFacetAccordion';
import t from '@jetshop/intl';
import { ElevateCheckbox } from './types/ElevateCheckbox';
import { css } from 'linaria';

const sortingCheckedStyle = css`
  font-weight: 700;
  color: #0d3923;
  background: #eee6de;

  input {
    width: 20px;
    height: 20px;
    display: inline-block !important;
    border-radius: 999px;
  }
`;

const initStyle = css`
  input {
    display: none;
  }
`;

export const ElevateSorting = ({ sort }) => {
  const { handleSortClick } = useElevate();

  return (
    <ElevateFacetAccordion title={t('Sort by')}>
      <ul>
        {sort?.options?.map(option => {
          return (
            <li key={`sort-${option.id}`}>
              <ElevateCheckbox
                checkedClass={sortingCheckedStyle}
                label={`${option.label}`}
                checked={option.id === sort.selected}
                onChange={() => handleSortClick(option.id)}
                type="radio"
                className={initStyle}
              />
            </li>
          );
        })}
      </ul>
    </ElevateFacetAccordion>
  );
};
